import axios from 'axios'
import _ from 'lodash'
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

const headers = {'Content-Type': 'application/json'}

export function getFacetDataDefaultFromServer(rqValues){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For favHotelsNow from Microservices DB swith sae key :' + rqValues)
    return dispatch => {
        dispatch(getFacetHotelsBegin())

        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/facetFilterhotels`
        //const url = 'http://localhost:8080/essearch/facetFilterhotels'
      
          
        axios.post(url, rqValues, {headers:headers})
        .then(
            r => {
                if(r.data.facetData){
                   
                    const comData = r.data.facetData
                   
                   
                    let newfacetData = { facetData : comData}
                    dispatch(getFacetHotelsSuccess(newfacetData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getFacetHotelsSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getFacetHotelsError(e))
        )
    }

}

export const getFacetHotelsBegin = () => dispatch => {
    dispatch({
        type:"facet/SOJOURNS_BEGIN"
        
    })
}

export const getFacetHotelsSuccess = (data) => dispatch => {
   
     dispatch({
        type: "facet/SOJOURNS_SUCCESS",
        payload: data
    })

   
}



export const getFacetHotelsError = (e) =>dispatch => {
    dispatch({
        type:"facet/SOJOURNS_ERROR",
        error:e
    })
}

export const saveFacetFilterCheckSuccess = (data) => dispatch => {
    console.log('sv*********saveFacetFilterCheckSuccess  start')
    console.log(data)
    console.log('sv*********saveFacetFilterCheckSuccess  end')
    let comData = {
        "checkedLmDisneyLabel":'Disaney Springs',
        "checkedLmDisney":true,
        "disabledLmDisney":false,
         //svst start
         checkedStFiveLabel:'5 Stars',
         checkedStFive:true,
         disabledStFive:false,

         checkedStFourLabel:'4 Stars',
         checkedStFour:true,
         disabledStFour:false,

         checkedStThreeLabel:'3 Stars',
         checkedStThree:true,
         disabledStThree:false,

         checkedStTwoLabel:'2 Stars',
         checkedStTwo:true,
         disabledStTwo:false,
 

         //svst end
        //svrs okay
        checkedRsExcellentLabel:'9+  Excellent',
        checkedRsExcellent:true,
        disabledRsExcellent:false,


        checkedRsGreatLabel:'8+ Great',
        checkedRsGreat:true,
        disabledRsGreat:false,

        checkedRsGoodLabel:'7+  Good',
        checkedRsGood:true,
        disabledRsGood:false,

        checkedRsOkayLabel:'5+ Okay',
        checkedRsOkay:true,
        disabledRsOkay:false,


        //svrs end
        //svfb start

        checkedFbCancellationLabel:'Free Cancellation',
        checkedFbCancellation:true,
        disabledFbCancellation:false,

        checkedFbInternetLabel:'Free Internet',
        checkedFbInternet:true,
        disabledFbInternet:false,


        checkedFbParkingLabel:'Free Parking',
        checkedFbParking:true,
        disabledFbParking:false,



        checkedFbBreakfastLabel:'Free Nreakfast',
        checkedFbBreakfast:true,
        disabledFbBreakfast:false,

        //svfb end
        

        "minBudgetPrice":20,
        "maxBudgetPrice":800,
        "valueSlider":100,
        
        "checkedParkingLabel":"Parking",
        "checkedParking":true,
        "disabledParking":false,

        "checkedWifiLabel":"Wifi",
        "checkedWifi":true,
        "disabledWifi":false,

        "checkedRestaurantLabel":"Restaurant",
        "checkedRestaurant":true,
        "disabledRestaurant":false,

        "checkedPetfriendlyabel":"pet Friendlly",
        "checkedPetfriendly":true,
        "disabledPetfriendly":false,

        "checkedRoomserviceLabel":"Room Service",
        "checkedRoomservice":true,
        "disabledRoomservice":false,

        "checkedFrontdeskLabel":"24 Hours Front Desk",
        "checkedFrontdesk":true,
        "disabledFrontdesk":false,

        "checkedFitnessLabel":"Fitness Center",
        "checkedFitness":true,
        "disabledFitness":false,

        "checkedNonsmokingLabel":"Non Smoking",
        "checkedNonsmoking":true,
        "disabledNonsmoking":false,

        "checkedShuttleLabel":"Airport Shuttle",
        "checkedShuttle":true,
        "disabledShuttle":false,

        "checkedFamilyroomsLabel":"Family Room",
        "checkedFamilyrooms":true,
        "disabledFamilyrooms":false,

        "checkedSpaLabel":"Spa",
        "checkedSpa":true,
        "disabledSpa":false,

        "checkedEvchargingLabel":"Electric Vehicle(EV) Charging",
        "checkedEvcharging":true,
        "disabledEvcharging":false,

        "checkedWheelchairLabel":"Wheel Chair Accessibility",
        "checkedWheelchair":true,
        "disabledFWheelchair":false

      
    }
    let newfacetData = { facetData : data.facetData, svfacet_myloc:data.svfacet_myloc}
    dispatch(getFacetHotelsSuccess(newfacetData))
/*
    dispatch({
        type: "facet/SOJOURNS_SUCCESS",
        payload: data
    })
    */
}